module.exports = __webpack_public_path__ + "static/img/30.f9b89f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/30.png
// module id = lP2W
// module chunks = 1